import { Activity, FileBox, FileText, Network } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";

import type { EntityLink, EntityLinkType } from "~/ai-chat/model/entity-link";

interface ChatEntityChipProps {
  link: EntityLink;
  children: ReactNode;
}

const ENTITY_ICONS: Record<EntityLinkType, typeof Network> = {
  system: Network,
  model: FileText,
  artifact: FileBox,
  job: Activity,
};

export function ChatEntityChip({ link, children }: ChatEntityChipProps) {
  const Icon = ENTITY_ICONS[link.type];

  return (
    <Link
      to={link.path}
      className="bg-background/60 text-foreground hover:bg-background inline-flex max-w-full items-baseline gap-1 rounded-full px-2 py-0.5 align-baseline text-xs font-medium shadow-[inset_0_0_0_1px_var(--border)] transition-[background-color,scale] duration-150 active:scale-[0.96]"
    >
      <Icon className="text-muted-foreground size-3 shrink-0 self-center" aria-hidden="true" />
      <span className="min-w-0 truncate">{children}</span>
    </Link>
  );
}
